import { ICostSummaryItem, ILineItem } from '../../CartContext.types';

export const useDevicePaymentHook = (
    lineItem: ILineItem,
    frequency: 'monthly' | 'dueToday'
): ICostSummaryItem => {
    if (frequency === 'monthly') {
        return {
            lineNumber: lineItem.lineNumber,
            itemName: `${lineItem.device?.product.baseInfo.name} - Installment Plan`,
            amount: lineItem.device?.monthlyPrice ?? 0,
            type: 'cost'
        };
    } else {
        return {
            lineNumber: lineItem.lineNumber,
            itemName: `${lineItem.device?.product.baseInfo.name} - Full Retail Price`,
            amount: lineItem.device?.productSku?.sku.price ?? 0,
            type: 'cost'
        };
    }
};
